// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"49c3fe1a264d8dbdd03f","678":"6909adf95062c54833a1","883":"f43df30c4f0d2e2c5804"}[chunkId] + ".js";
};